import { Text, Link } from "@simplybusiness/mobius";

type OfflinePurchaseTextProps = {
  offlinePurchaseOnlyText: string | undefined;
  offlinePurchaseOnlyNumber: string | undefined;
  isMobile: boolean | undefined;
};

export const OfflinePurchaseText = ({
  offlinePurchaseOnlyText,
  offlinePurchaseOnlyNumber,
  isMobile,
}: OfflinePurchaseTextProps) => (
  <Text
    data-testid="pricing-sub-text"
    className="mobius-quote-card__bind-sub-text"
  >
    {offlinePurchaseOnlyText} &nbsp;
    {isMobile ? (
      <Link href={`tel:${offlinePurchaseOnlyNumber}`}>
        {offlinePurchaseOnlyNumber}
      </Link>
    ) : (
      <Text className="mobius-quote-card__bind-phone-number">
        {offlinePurchaseOnlyNumber}
      </Text>
    )}
  </Text>
);
